// extracted by mini-css-extract-plugin
export default {"catalog_all":"styles_catalog_all__2w8ph","catalog_1":"styles_catalog_1__59+qh","catalog_2":"styles_catalog_2__O70iy","catalog_3":"styles_catalog_3__VMx-r"};